export function Card({ title, children, className = '' }) {
  return (
    <div
      className={[
        'rounded-2xl border border-slate-200 bg-white p-6 shadow-sm',
        className,
      ].join(' ')}
    >
      {title && (
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      )}
      <div className={title ? 'mt-3 text-sm leading-6 text-slate-700' : ''}>
        {children}
      </div>
    </div>
  );
}

